<template>
    <div class="row no-margins flex-row">
        <div class="col-md-2 pull-left flex-container">
            <div class="d-flex align-center justify-center" style="width: 105px;">
                <v-select-custom
                    :value="t_limit"
                    @input="$emit('update:limit', t_limit)"
                    :items="limitItems"
                    :label="`${t_show} ${t_entries}`"
                />
            </div>
        </div>
        <div v-if="pages > 1" class="col-md-10">
            <ul class="pagination pull-right no-margins">
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="first">
                        <i class="fa fa-fast-backward"></i>
                    </a>
                </li>
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="prev">
                        <i class="fa fa-backward"></i>
                    </a>
                </li>
                <li class="footable-page">
                    <a href="#">
                        {{ pageof }}
                    </a>
                </li>
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="next">
                        <i class="fa fa-forward"></i>
                    </a>
                </li>
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="last">
                        <i class="fa fa-fast-forward"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

    export default {
        props: [
            'page',
            'pages',
            'limit',
        ],
        watch: {
            limit: function() {
                this.t_limit = this.limit;
            },
        },
        computed: {
            pageof: function () {
                return Lang.langGet("Page :page of :maxpage", {page: this.page + 1, maxpage: this.pages})
            },
            limitItems() {
                return this.limits.map(limit => ({value: limit, text: limit}));
            }
        },
        data() {
            return {
                limits:         [10, 25, 50, 100],
                t_limit:        25,
                t_show:         Lang.langGet("Show"),
                t_entries:      Lang.langGet("entries"),
            }
        },
        methods: {
            first: function () {
                this.$emit('update:page', 0);
            },
            last: function () {
                this.$emit('update:page', this.pages - 1);
            },
            prev: function () {
                if (this.page <= 1) {
                    this.first();
                } else {
                    this.$emit('update:page', this.page - 1);
                }
            },
            next: function () {
                if (this.page === this.pages - 1) {
                    this.last();
                } else {
                    this.$emit('update:page', this.page + 1);
                }
            },
            mounted() {
                this.t_limit = this.limit;
            }
        }
    }
</script>

<style scoped>
    .flex-row {
        display: flex;
        align-items: baseline;
    }

    .flex-container {
        display: flex;
        justify-content: left;
        gap:    5px;
    }
</style>
